import { useEffect, useState } from 'react';

export enum ScreenSize {
	SMALL = '(max-width: 767px)',
	MEDIUM = '(max-width: 1023px)',
	LARGE = '(max-width: 1439px)',
	XLARGE = '(min-width: 1440px)',
}

export function useMediaQuery(query: `${ScreenSize}`): boolean {
	const [matches, setMatches] = useState(false);

	useEffect(() => {
		const mediaQuery = window.matchMedia(query);
		if (mediaQuery.matches !== matches) {
			setMatches(mediaQuery.matches);
		}

		const listener = () => {
			setMatches(mediaQuery.matches);
		};

		mediaQuery.addEventListener('change', listener);

		return () => {
			mediaQuery.removeEventListener('change', listener);
		};
	}, [matches, query]);

	return matches;
}
